export default {
    upload: 'image/upload'
};